module.exports = __webpack_public_path__ + "img/大兵.7c84f2fa.gif";